const BILLING_DEADLINE_DAYS = {
  0: 5,
  1: 10,
  2: 15,
  3: 20,
  4: 25
};

const addMonths = (date, months) => {
  return new Date(date.getFullYear(), date.getMonth() + months, 1);
};

const deadlineDayFor = (billingDeadline) => {
  if (billingDeadline === null || billingDeadline === undefined || billingDeadline === '') {
    return null;
  }

  return BILLING_DEADLINE_DAYS[Number(billingDeadline)] || null;
};

export const formatYearMonth = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${date.getFullYear()}-${month}`;
};

export const billingDeadlineLabel = (billingDeadline) => {
  const deadlineDay = deadlineDayFor(billingDeadline);
  return deadlineDay ? `${deadlineDay}日` : '月末';
};

export const defaultCustomerChangeEffectiveMonth = (billingDeadline, today = new Date()) => {
  const deadlineDay = deadlineDayFor(billingDeadline);
  const isAfterDeadline = deadlineDay ? today.getDate() > deadlineDay : false;

  // 締日前（締日当日を含む）は翌月、締日後は翌々月を初期値とする。
  return formatYearMonth(addMonths(today, isAfterDeadline ? 2 : 1));
};
